module.exports = __webpack_public_path__ + "static/piano-f33323c7136c00245923f63290372736.mp3";